import { IMeetingResponse, IJoinResponse } from './types';
import { getApi } from '../apiClient';

export async function getMeeting(id: number): Promise<IMeetingResponse> {
  const { data } = await getApi().get<IMeetingResponse>(`/meetings/${id}`);

  return data;
}

export async function createReservation(id: number): Promise<IMeetingResponse> {
  const { data } = await getApi().post<IMeetingResponse>(`/meetings/${id}/reservation`);

  return data;
}

export async function removeReservation(id: number): Promise<IMeetingResponse> {
  const { data } = await getApi().delete<IMeetingResponse>(`/meetings/${id}/reservation`);

  return data;
}

export async function joinClass(id: number): Promise<IJoinResponse> {
  const { data } = await getApi().get<IJoinResponse>(`/meetings/${id}/join`);

  return data;
}
